/**
 * @file Computes the invested amount for one tier of an investment, as a raw number or a currency string.
 */
import { getFormattedDecimalValue, getCurrencyValue } from "@components/Amount";

import type { TierInvestment } from "../types";

type TieredInvestment = {
  investments: TierInvestment[];
};

/**
 * Returns the invested amount for the given tier, or undefined when the investment has no such tier.
 */
export const getInvestmentTierAmount = (
  tierId: string,
  { investments }: TieredInvestment,
): number | undefined => {
  const tierInvestment = investments
    .find(({ projectTierId }) => projectTierId === tierId);

  if (!tierInvestment) {
    return undefined;
  }

  const { amount } = tierInvestment;

  return amount;
};

/**
 * Returns the invested amount for the given tier formatted as a currency string, or null when there is none.
 */
export const getInvestmentTierCurrency = (
  tierId: string,
  investment: TieredInvestment,
): string | null => {
  const amount = getInvestmentTierAmount(tierId, investment);

  const currencyValue = amount
    ? getCurrencyValue(getFormattedDecimalValue(0, amount, "plus"))
    : null;

  return currencyValue;
};

export { getCurrencyValue };
